import React, { useState, useEffect } from 'react';
import RouterPropsWrapper from '../../../../common/RouterPropsWrapper';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import { useChallengeInstance } from '../../../../hooks/useChallengeInstance';
import { useChallenge } from '../../../../hooks/useChallenge';
import { useEvaluateStep } from '../../../../hooks/useEvaluateStep';
import ChallengePanel from '../../ChallengePanel';
import LineItemsSimulation from "../LineItemsSimulation";
import { campaignVar, creativesVar, creativeVar, lineItemsVar, lineItemVar } from '../../../../settings/cache';
import SandboxLayout from "../../../../hoc/SandboxLayout/SandboxLayout";
import { campaignAdsManagerData } from "../../../../utils/data/sandboxes";

const CampaignAdServerStep5 = (props) => {
  const { match, history } = props;
  const challengeId = match.params.id;
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stepTime, setStepTime] = useState(0);
  
  // Fetch challenge instance data
  const { data: challengeInstanceData, isLoading: isLoadingInstance, error: errorInstance } = useChallengeInstance(challengeId);
  
  const challengeType = challengeInstanceData?.challengeInstance?.challengeType;
  const currentStep = challengeInstanceData?.challengeInstance?.currentStep;
  
  // Fetch challenge data
  const { data: challengeData, isLoading: isLoadingChallenge, error: errorChallenge } = useChallenge(challengeType);
  
  const evaluateStepMutation = useEvaluateStep();

  // Initialize cache variables on mount
  useEffect(() => {
    campaignVar({});
    creativesVar([]);
    creativeVar({});
    lineItemsVar([]);
    lineItemVar({});
  }, []);

  // Start step timer
  useEffect(() => {
    const timer = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleTab = () => {
    // Not implemented
  };

  const submit = async () => {
    try {
      setIsSubmitting(true);
      const action = {
        actionNeeded: 'click',
        target: 'button',
        parameter: 'save',
        stepTime: stepTime
      };
      console.log(action.target);
      const res = await evaluateStepMutation.mutateAsync({
        challengeId: challengeId,
        action: action,
        challengeToDo: null
      });
      const value = res.challengeStepEvaluator?.targetLocation || '';
      console.log(value);
      if (value !== '') {
        history.push(value + challengeId);
      } else {    
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error('Error submitting:', err);
      setIsSubmitting(false);
    }
  };

  if (isLoadingInstance || isLoadingChallenge) return <LoadingAnimation />;
  if (errorInstance) return <div>Error loading challenge instance: {errorInstance.message}</div>;
  if (errorChallenge) return <div>Error loading challenge: {errorChallenge.message}</div>;
  if (!challengeType) return <LoadingAnimation />;

 const challenge = challengeData?.challengeDefinition ? (typeof challengeData.challengeDefinition === 'string' ? JSON.parse(challengeData.challengeDefinition) : challengeData.challengeDefinition) : null;
  if (!challenge) return <div>No data available</div>;

  const step = parseInt(currentStep);
  const StepCountDownTime = challenge.steps[4]?.countdownTime;
  let items = [];
  if (challenge.steps[step])
    items = challenge.steps[step].data;

  return (
    <SandboxLayout name="Campaigns" challengeMode={true} layoutData={campaignAdsManagerData}>
      <div className="wizard-container">
        <div className="col-md-12 col-12 mr-auto ml-auto">
          <div className="card card-wizard active" data-color="rose" id="wizardProfile">
            <div>
              <div>
                <LineItemsSimulation
                  handleTab={handleTab}
                  caption="Line Items"
                  submit={submit}
                  name=""
                  id={challengeId}
                  items={items}
                  isSubmitting={isSubmitting}
                />
                <ChallengePanel
                  time={StepCountDownTime}
                  description={challenge.challengeDescription}
                  coach={challenge.coach}
                  challengeTitle={challenge.challengeTitle}
                  challengeIsValidation={challenge.isValidation}
                  challengeDifficulty={challenge.challengeDifficulty}
                  challengeAverageTime={challenge.averageTime}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SandboxLayout>
  );
};

export default RouterPropsWrapper(CampaignAdServerStep5);
